import { ApiBase } from './ApiBase';
class PublicTokenApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getPublicTokens = () => {
            return this.get('/public-tokens');
        };
        this.createPublicToken = () => {
            return this.post('/public-tokens', {});
        };
        this.removePublicToken = (token) => {
            return this.delete(`/public-tokens/${token}`);
        };
    }
}
export const PublicTokenApiClient = new PublicTokenApiClientModel();
